import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SupplierCatComponent } from '../supplier-cat/supplier-cat.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-supplier-cat-list',
  templateUrl: './supplier-cat-list.component.html',
  styleUrls: ['./supplier-cat-list.component.css']
})
export class SupplierCatListComponent implements OnInit {

  public menu_item_id = '31';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['supplier_category_name', 'supplier_category_name_en', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<SupplierCatComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'supplier_category', 'supplier_category_name': '', 'supplier_category_name_en': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {
    let condition = "";

    if (this.model['supplier_category_name'] != '')
      condition = " (`supplier_category_name` LIKE '%" + this.model['supplier_category_name'] +
        "%' OR `supplier_category_name_en` LIKE '%" + this.model['supplier_category_name'] + "%') AND ";

    let query = "SELECT * FROM `supplier_category` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newSupCatEntry() {
    this.addDialogRef = this.dialog.open(SupplierCatComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
        //console.log(this.acct_income);
      });
  }

  editSuppCat(row) {
    let dialog_data = {
      'table_name': 'supplier_category', 'supplier_category_id': row.supplier_category_id,
      'supplier_category_name': row.supplier_category_name,
      'supplier_category_name_en': row.supplier_category_name_en, 'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(SupplierCatComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delSuppCat(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'supplier_category_id': row.supplier_category_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
